import { useState } from "react";

const LETTERS = ["A", "B", "C", "D", "E", "F", "G", "H"];

// Renders the admin-flagged free sample questions on a module's catalog preview.
// Each question shows its stem and options; a "Reveal answer" toggle exposes the
// correct option and the worked rationale. Read-only — no submission, no scoring.
function SampleQuestion({ question, index }) {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className="cand-sample">
      <div className="cand-sample__num">Sample {index + 1}</div>
      <div className="cand-sample__stem">{question.stem}</div>

      <ol className="cand-sample__options">
        {question.options.map((option, i) => {
          const isCorrect = revealed && i === question.correct_index;
          return (
            <li
              key={i}
              className={`cand-sample__option${isCorrect ? " --correct" : ""}`}
            >
              <span className="cand-sample__letter">{LETTERS[i] || i + 1}</span>
              <span>{option.text}</span>
              {isCorrect && <span className="cand-sample__tick">✓</span>}
            </li>
          );
        })}
      </ol>

      {!revealed && (
        <button
          type="button"
          className="cand-btn --sm"
          onClick={() => setRevealed(true)}
        >
          Reveal answer
        </button>
      )}

      {revealed && question.rationale && (
        <div className="cand-sample__rationale">
          <div className="cand-sample__rationale-label">Why</div>
          {question.rationale}
        </div>
      )}
    </div>
  );
}

export default function SamplePreview({ questions = [] }) {
  if (questions.length === 0) return null;

  return (
    <div className="cand-sample-list">
      {questions.map((question, index) => (
        <SampleQuestion key={question.id ?? index} question={question} index={index} />
      ))}
    </div>
  );
}
